// pets.js - Controller functions for pet management
import { post } from './utilitiesController';

/**
 * Get pet details from universal ID
 * @param {string} petId - The universal pet ID
 * @returns {Promise} - Response from pet details endpoint
 */
export const getPetDetailsFromUniversalId = async (petId) => {
    try {
        console.log('Making API call to get pet details with universal ID:', petId);
        
        const response = await post('api/pets/get_from_universal_id', { 
            universal_pet_id: petId 
        }, true);
        
        console.log('Get Pet Details API response received:', response);
        return response;
    } catch (error) {
        console.error('Failed to fetch pet details:', error);
        console.error('Error details:', error.response?.data || error.message);
        throw error;
    }
};


export const getDerivedPet = async (petId) => {
    try {
        // Client-side validation
        if (!petId || petId.trim() === '') {
            throw new Error('Pet ID is required and cannot be empty');
        }
        
        const response = await post('api/pets/get_derived_pet', { 
            pet_id: petId 
        }, true);
        
        return response;
    } catch (error) {
        console.error('Failed to fetch derived pet data:', error);
        console.error('Error details:', error.response?.data || error.message);
        
        // Handle specific HTTP status codes
        if (error.response?.status === 400) {
            throw new Error('Invalid request: Pet ID is missing or empty');
        } else if (error.response?.status === 401 || error.response?.status === 403) {
            throw new Error('Authentication required. Please log in again.');
        } else if (error.response?.status === 404) {
            throw new Error('Pet not found');
        } else if (error.response?.status === 500) {
            throw new Error('Server error occurred. Please try again later.');
        }
        
        throw error;
    }
};


export const evaluatePotentialDuplicates = async (petId) => {
    try {
        console.log('Making API call to evaluate potential duplicates for pet:', petId);
        const response = await post('api/pets/evaluate_potential_duplicates', {
            pet_id: petId
        }, true);
        console.log('Evaluate Potential Duplicates API response received:', response);
        return response;
    } catch (error) {
        console.error('Failed to evaluate potential duplicates:', error);
        console.error('Error details:', error.response?.data || error.message);
        throw error;
    }
};

export const mergeDuplicatePet = async ({ pet_incubation_id, universal_pet_id }) => {
    try {
        if (!pet_incubation_id || typeof pet_incubation_id !== 'string' || pet_incubation_id.trim() === '') {
            throw new Error('pet_incubation_id is required');
        }
        if (!universal_pet_id || typeof universal_pet_id !== 'string' || universal_pet_id.trim() === '') {
            throw new Error('universal_pet_id is required');
        }

        const payload = {
            pet_incubation_id: pet_incubation_id.trim(),
            universal_pet_id: universal_pet_id.trim()
        };

        const response = await post('api/pets/merge_duplicate_pet', payload, true);
        return response;
    } catch (error) {
        // Allow caller to handle status-specific flows
        throw error;
    }
};
